// Shared Firebase configuration
// Safe to expose - these are public keys
export const firebaseConfig = {
    apiKey: "AIzaSyBPQk8DKDZvO88IL5War-0k-GLFmCvqeIg",
    authDomain: "ddoaudit.firebaseapp.com",
    projectId: "ddoaudit",
    storageBucket: "ddoaudit.firebasestorage.app",
    messagingSenderId: "808002047047",
    appId: "1:808002047047:web:251d7d87c213ffd1233562",
    measurementId: "G-L54PGXRRZV",
}

export const vapidKey =
    "BHURfrHrbo1yse50tNgR-NY_kfrd8oLuzTOugV448qabSRjwKmZh8G63yRA0d_CXtSSU773dXwaFPGMdQkCU0R0"
